import { readFavorites, writeFavorites } from '@/utils/storage';

export function isFavorite(id: string): boolean {
  return readFavorites().includes(id);
}

export function toggleFavorite(id: string): boolean {
  const list = readFavorites();
  const exists = list.includes(id);
  const next = exists ? list.filter((item) => item !== id) : [id, ...list];
  writeFavorites(next);
  return !exists;
}